const config = {
  builder_id: '5df3ce6d4db0484ff65861a2',
  auth_domain: 'solerareserve.com',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'logo',
    home: 'photos[0]',
  },
  social_links: {
    facebook: '/images/icon-social-facebook.svg',
    instagram: '/images/icon-social-instagram.svg',
    youtube: '/images/icon-social-youtube.svg',
    pinterest: '/images/icon-social-pinterest.svg',
    twitter: '/images/icon-social-twitter.svg',
    houzz: '/images/icon-social-houzz.svg',
    linkedin: '/images/icon-social-linkedin.svg',
    googleplus: '/images/icon-social-google-plus.svg',
    fallback: '/images/icon-social-baths.svg',
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2s1MnhrbDI1MDJxcTNvbXBwNzdpc3ZydyJ9.JfIrdttYuL8edv_OIUauCQ',
    tileUrl: 'https://api.mapbox.com/styles/v1/builderdesigns/ck52wwnnp1m0j1co0tjsem6w5/tiles/256/{z}/{x}/{y}',
  },
  filters: {
    all: {},
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js